import { PanelProps, Panel as PrimePanel } from 'primereact/panel';
import { MutableRefObject, ReactNode, useMemo, useState } from 'react';
import { Button } from '../../Button/Button';
import { Icon } from '../../Icon/Icon';

export function ContentOnlyHeaderTemplate(
    props: PanelProps,
    panelRef: MutableRefObject<PrimePanel | null>,
): ReactNode {
    const [isCollapsed, setCollapsed] = useState<boolean>(
        props.collapsed ?? false,
    );

    const buttonClass = useMemo(() => {
        if (isCollapsed) return 'active';
        return '';
    }, [isCollapsed]);

    const buttonIcon = useMemo(() => {
        if (isCollapsed) return 'keyboard_arrow_down';
        return 'keyboard_arrow_up';
    }, [isCollapsed]);

    const buttonText = useMemo(() => {
        if (isCollapsed) return 'Show';
        return 'Hide';
    }, [isCollapsed]);

    return (
        <div className="flex justify-content-between p-panel-header">
            <h4>{props.header}</h4>
            <Button
                tertiary
                label={buttonText}
                className={buttonClass}
                icon={<Icon name={buttonIcon} />}
                iconPos="right"
                onClick={() => {
                    setCollapsed(!isCollapsed);
                    panelRef.current?.toggle(undefined);
                }}
                style={{
                    minWidth: '77px',
                }}
            />
        </div>
    );
}
